export default "__VITE_ASSET__S6Kq0sOV__"